<template>
    <fragment>
        <div id="wrap">
            <skp-gnb @router-reload="routerReload()"></skp-gnb>

            <!-- container -->
            <div id="container">
                <div class="container_wrap">
                    <!-- snb -->
                    <keep-alive>
                        <admin-snb></admin-snb>
                    </keep-alive>
                    <!-- //snb -->

                    <!-- contents -->
                    <router-view :key="$route.fullPath"></router-view>
                    <!-- //contents -->
                </div>
            </div>
            <!-- //container -->

            <!-- FOOTER -->
            <keep-alive>
                <skp-footer />
                <!-- //FOOTER -->
            </keep-alive>
        </div>
        <div class="goto_top">
            <a href="javascript:" class="scroll_top_btn"><span class="sr_only">TOP</span></a>
        </div>
    </fragment>
</template>

<script>
// import axios from 'axios';
// import SDLUtil from '@/utils/SDLUtil';
import $ from 'jquery';
import SKPGnb from '~vb/main/SKPGnb';
import AdminSnb from '~va/main/AdminSnb';
import SKPFooter from '~vb/main/SKPFooter';

export default {
    data() {
        return {};
    },
    components: {
        'skp-gnb': SKPGnb,
        'admin-snb': AdminSnb,
        'skp-footer': SKPFooter,
    },
    methods: {
        btnGotoTop() {
            $(window).scroll(function() {
                if ($(this).scrollTop() > 200) {
                    $('.goto_top').fadeIn();
                } else {
                    $('.goto_top').fadeOut();
                }
            });

            $('.scroll_top_btn').click(function() {
                $('html, body').animate(
                    {
                        scrollTop: 0,
                    },
                    400,
                );
                return false;
            });
        },
    },
    created() {
        if ($('body').hasClass('admin_wrap') === false) $('body').addClass('admin_wrap');
    },
    mounted() {
        this.btnGotoTop();
    },
};
</script>

<style scoped>
html /deep/ {
    @import url('/static/css/hhp_admin.css');
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/EurAdminMain.vue